<template>
<div id="contents">

  <div id="works" class="page_contents">

    <div id="works_contents">
      <div id="works_drawn_show" v-if="drone">

        <div id="works_drawn_show_main" class="page_main_contents">
          <h1 v-html="drone.title"></h1>

          <div id="works_drawn_show_movie">
            <video :src="drone.movie_file" :poster="drone.kv_image" ref="video"  controls></video>
          </div>

          <p class="page_close"><a href="#"><img src="../assets/img/common/page/close_icon.png" width="55" alt="閉じるボタン" ></a></p>
          <p class="page_close"><router-link v-bind:to="{name: 'drawn_index'}"><img src="../assets/img/common/page/close_icon.png" width="55" alt="閉じるボタン" ></router-link></p>
        </div><!-- #works_program_show_main -->

        <div class="contact_btn_wrap">
          <p class="contact_btn"><router-link v-bind:to="{ name : 'contact', params : { referrer: 'ドローン事業について' }}" class="c_link">ドローン撮影に関する<br />お問い合わせはこちら</router-link></p>
        </div><!-- .contact_btn_wrap -->

        <ul id="page_nav">
          <p v-if="drone.next_post_id"><router-link v-bind:to="{name: 'drawn_show', params: {id: drone.next_post_id}}"><img src="../assets/img/common/page/arrow.png" width="20" alt="右矢印" ></router-link></p>
          <p v-else></p>

          <p v-if="drone.prev_post_id"><router-link v-bind:to="{name: 'drawn_show', params: {id: drone.prev_post_id}}"><img src="../assets/img/common/page/arrow.png" width="20" alt="左矢印" ></router-link></p>
          <p v-else></p>
        </ul><!-- #page_nav -->

      </div><!-- #works_drawn_show -->
    </div><!-- #works_contents -->
  </div><!-- #works -->



</div><!-- #contents -->
</template>

<script>
export default {
  name: 'drawn_show',
  data() {
    return {
      api_url: this.$parent.api_base_url+'/api/drone/show.php',
      drone: null,
      error: null
    }
  },
  methods: {
    fetch_drone(){
      this.$axios
        .get(this.api_url ,{
          params: {
            id: this.$route.params.id
          }
        })
        .then(response => {
          this.drone = response.data.item[0]
        })
        .catch(error => {
          console.log(error)
          this.error = true
        })
        .finally(() => {
          var video = this.$refs.video;
        	  video.addEventListener('ended', function() {
            video.load();
          }, false);
        })
    }
  },
  watch: {
    '$route' (to, from) {
      this.fetch_drone()
    }
  },
  mounted () {
    this.fetch_drone()
    this.$emit('page_fade')
    console.log(this.$refs)
  },
  updated (){
    this.$emit('page_fade')
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/drawn_show.vue